export const set = (state, data) => {
  state.records = data;
};

export const create = (state, data) => {
  state.records.push(data);
};

export const setSingleRecord = (state, data) => {
  const recordIndex = state.records.findIndex(record => record.id === data.id);
  if (recordIndex > -1) {
    state.records[recordIndex] = data;
  } else {
    create(state, data);
  }
};

export const update = (state, data) => {
  const index = state.records.findIndex(element => element.id === data.id);
  if (index !== -1) {
    // Create a new array to ensure Vue reactivity detects the change
    state.records = [
      ...state.records.slice(0, index),
      data,
      ...state.records.slice(index + 1),
    ];
  }
};

/* when you don't want to overwrite the whole object */
export const updateAttributes = (state, data) => {
  state.records.forEach((element, index) => {
    if (element.id === data.id) {
      state.records[index] = { ...state.records[index], ...data };
    }
  });
};

export const updatePresence = (state, data) => {
  state.records.forEach((element, index) => {
    const availabilityStatus = data[element.id];
    state.records[index].presence_status = availabilityStatus || 'offline';
  });
};

export const updateSingleRecordPresence = (
  records,
  { id, availabilityStatus }
) => {
  const [selectedRecord] = records.filter(record => record.id === Number(id));
  if (selectedRecord) {
    selectedRecord.presence_status = availabilityStatus;
  }
};

export const destroy = (state, id) => {
  state.records = state.records.filter(record => record.id !== id);
};
